import React from 'react';
import '../../App.css';

export default function Loyalty() {
  return <h1 className='loyalty'>LIKE & SUBSCRIBE</h1>;
}
